export enum SurveyStatus {
  Pending = 'Pending',
  ManualInput = 'Manual input',
  Requested = 'Requested',
  InProgress = 'In Progress',
  Finished = 'Finished'
}
